import { render, staticRenderFns } from "./distributedTask.vue?vue&type=template&id=6f10298a&scoped=true"
import script from "./distributedTask.vue?vue&type=script&lang=js"
export * from "./distributedTask.vue?vue&type=script&lang=js"
import style0 from "./distributedTask.vue?vue&type=style&index=0&id=6f10298a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f10298a",
  null
  
)

export default component.exports